module.exports = __webpack_public_path__ + "static/media/borta.8745d62b.mp3";